import React from 'react';

import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';

import styles from './styles.module.scss';

const ContentBankruptcy = () => (
  <Space direction="vertical" size={8} className="h-mt-12">
    <Text size={10} className={styles.tag} uppercase strong>
      Бесплатная консультация
    </Text>
    <Text size={14} className="h-color-D100">
      Законное списание долгов – поможем разобраться как это работает
    </Text>
    <br />
    <br />
    <br />
    <br />
  </Space>
);

export { ContentBankruptcy };
